
const schemaData = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "LocalBusiness",
      "@id": `${import.meta.env.VITE_SITE_URL}/#business`,
      "name": "Bridgend Electricians",
      "alternateName": "Megalec",
      "url": import.meta.env.VITE_SITE_URL,
      "telephone": "+441656497474",
      "email": "info@megalec.co.uk",
      "description": "Professional NAPIT approved electricians in Bridgend, South Wales. Offering rewiring, EICR testing, EV charger installation, consumer unit upgrades, and 24/7 emergency callouts.",
      "priceRange": "££",
      "image": "https://i.ibb.co/TMsvh7wH/IMG-3557-1.jpg",
      "logo": "https://i.ibb.co/TMsvh7wH/IMG-3557-1.jpg",
      "address": {
        "@type": "PostalAddress",
        "addressLocality": "Bridgend",
        "addressRegion": "South Wales",
        "addressCountry": "GB",
        "postalCode": "CF31"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": 51.5045,
        "longitude": -3.5767
      },
      "areaServed": [
        { "@type": "City", "name": "Bridgend" },
        { "@type": "State", "name": "South Wales" },
        { "@type": "City", "name": "Cardiff" },
        { "@type": "City", "name": "Swansea" },
        { "@type": "City", "name": "Port Talbot" }
      ],
      "openingHoursSpecification": [
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
          "opens": "08:00",
          "closes": "18:00"
        },
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": "Saturday",
          "opens": "09:00",
          "closes": "14:00"
        }
      ],
      "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": "Electrical Services",
        "itemListElement": [
          { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Full & Partial Rewiring" } },
          { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Consumer Unit Upgrades" } },
          { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "EICR Testing" } },
          { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "EV Charger Installation" } },
          { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Emergency Electrical Callouts" } },
          { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Landlord Safety Certificates" } },
          { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Smart Home Installations" } },
          { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Fire Alarm Systems" } }
        ]
      },
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "5.0",
        "reviewCount": "6",
        "bestRating": "5",
        "worstRating": "1"
      },
      "review": [
        {
          "@type": "Review",
          "author": { "@type": "Person", "name": "Andrew Richards" },
          "reviewRating": { "@type": "Rating", "ratingValue": "5", "bestRating": "5" },
          "reviewBody": "Just want to say how simple it was getting the electrics tested in the property I was purchasing. Kevin got in touch with me and confirmed everything such as dates and timescales for the report. Would recommend."
        },
        {
          "@type": "Review",
          "author": { "@type": "Person", "name": "Lynela W" },
          "reviewRating": { "@type": "Rating", "ratingValue": "5", "bestRating": "5" },
          "reviewBody": "At last, a tradesman who turns up when he says he will, and does a really good job at a reasonable price. Very nice guy too. 100% recommend."
        },
        {
          "@type": "Review",
          "author": { "@type": "Person", "name": "Mark Davies" },
          "reviewRating": { "@type": "Rating", "ratingValue": "5", "bestRating": "5" },
          "reviewBody": "Brilliant service from start to finish. Kevin was professional, punctual and very knowledgeable. Rewired our entire house and the finish was immaculate. Highly recommend."
        }
      ],
      "sameAs": [
        "https://www.megalec.co.uk"
      ]
    },
    {
      "@type": "WebSite",
      "@id": `${import.meta.env.VITE_SITE_URL}/#website`,
      "url": import.meta.env.VITE_SITE_URL,
      "name": "Bridgend Electricians",
      "description": "Professional NAPIT approved electricians in Bridgend and South Wales",
      "publisher": {
        "@id": `${import.meta.env.VITE_SITE_URL}/#business`
      }
    },
    {
      "@type": "WebPage",
      "@id": `${import.meta.env.VITE_SITE_URL}/#webpage`,
      "url": import.meta.env.VITE_SITE_URL,
      "name": "Electrician Bridgend | NAPIT Approved | Bridgend Electricians",
      "description": "Professional electricians in Bridgend. NAPIT approved, fully insured. Rewiring, EICR testing, EV chargers, emergency callouts. Covering Bridgend and South Wales.",
      "isPartOf": { "@id": `${import.meta.env.VITE_SITE_URL}/#website` },
      "about": { "@id": `${import.meta.env.VITE_SITE_URL}/#business` },
      "inLanguage": "en-GB"
    },
    {
      "@type": "FAQPage",
      "@id": `${import.meta.env.VITE_SITE_URL}/#faq`,
      "mainEntity": [
        {
          "@type": "Question",
          "name": "Are you NAPIT approved electricians in Bridgend?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Yes, we are fully NAPIT approved and 18th Edition certified electricians based in Bridgend, South Wales. All our work is fully insured and compliant with current regulations."
          }
        },
        {
          "@type": "Question",
          "name": "Do you offer 24/7 emergency electrical callouts in Bridgend?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Yes, we provide 24/7 emergency electrical callout services throughout Bridgend and the surrounding South Wales area. Call us on 01656 497474 any time."
          }
        },
        {
          "@type": "Question",
          "name": "What areas do you cover for electrical services?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "We cover Bridgend and the wider South Wales region including Cardiff, Swansea, Port Talbot, and surrounding towns and villages."
          }
        },
        {
          "@type": "Question",
          "name": "Do you provide free quotes for electrical work in Bridgend?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Yes, we offer free, no-obligation quotes for all electrical projects in Bridgend and South Wales. Contact us via phone or our online form to arrange a quote."
          }
        },
        {
          "@type": "Question",
          "name": "Can you install EV chargers in Bridgend?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Yes, we are fully qualified to install EV (electric vehicle) chargers at domestic and commercial properties throughout Bridgend and South Wales."
          }
        }
      ]
    }
  ]
};

export default function SchemaOrg() {
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaData) }}
    />
  );
}